import React,{ useEffect, useState} from "react";
import SectionCanChat from "../sections/chat/section-can-chat";
import SectionCanChatList from "../sections/chat/section-can-chat-list";
import { loadScript } from "../../../../globals/constants";
import {getDocs, collection, query, where, onSnapshot} from 'firebase/firestore';
import { db } from "../../../common/firebase/firebase";
import { useSelector } from "react-redux";
import CanJobList from "./can-chat-joblists";
import apiCall from "../../../../apicall";
import { useParams, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { formatCompanyName } from "../../../../globals/fomat-comapny-name";
import { logEvent_Analytics } from "../../../common/firebase/firebase-analytics-service";

function CanChatPage() {
    const { id } = useParams();
    const location = useLocation();
    const [jobId,setJobId]=useState(null)
    const [selectedChatJobId, setSelectedChatJobId] = useState(null)
    const [chatList,setChatList]=useState([])
    const [jobLists,setJobLists]=useState([])
    const [isJobList,setIsJobList]=useState(false)
    const [searchValue,setSearchValue]=useState('')
    const { isLoggedIn, userInfo, role_type,TOKEN, } = useSelector(
      (state) => state.menu
    );
    const [isGroupChat, setIsGroupChat] = useState(false);
    const [jobIdAndGroupStatus, setJobIdAndGroupStatus] = useState({
      jobId: '',
      isGroupChat: false
    })
    const [adminDetails, setAdminDetails] = useState();
    const [isStartChat, setIsStartChat] = useState(false);

    // const isAdmin = userInfo?.roleEntities[0]?.roleType=="ROLE_OPENSTAFF_ADMIN";
    const adminRoles = [
      "ROLE_OPENSTAFF_ADMIN",
      "ROLE_SEEKER_USER_ADMIN",
      "ROLE_INSTITUTION_POSTER_ADMIN",
      "ROLE_OPENSTAFF_FINANCIAL_ADMIN"
    ];

    const userRoleType = userInfo?.roleEntities?.[0]?.roleType;
    const isAdmin = adminRoles?.includes(userRoleType);

    const userId = userInfo?.id;
    useEffect(() => {
        fetchJobList();
        fetchUsersList();
         logEvent_Analytics('chat_list_web');
      }, []);
      useEffect(() => {
        // Call getAllChats when component mounts or dependencies change
        const unsubscribe = getAllChats(isAdmin, userId, searchValue, setIsJobList, setJobId, setChatList);
        return () => {
          if (unsubscribe instanceof Promise) {
            unsubscribe.then(unsub => {
              if (typeof unsub === 'function') {
                unsub();
              }
            });
          } else if (typeof unsubscribe === 'function') {
            unsubscribe();
          }
        };
      }, [isAdmin, userId, searchValue]);

      // useEffect(() => {
      //  const searchParams = new URLSearchParams(location.search);
      //  const isGroup = searchParams.get("isGroup");
      //  setIsGroupChat(isGroup)
      //  console.log("isGroup========",isGroup)
      // }, [location?.search, id])
    
      const getAllChats = async (isAdmin, userId, searchValue, setIsJobList, setJobId, setChatList) => {
        try {
          const chatsRef = collection(db, 'chats');
          const groupChatsRef = collection(db, "groupChats"); 
          let chatDocs = [];
          let groupChatDocs = [];

          let q1, q2, qGroup;
      
          if (isAdmin) {
            // Admin: Fetch all chat documents based on searchValue (if provided)
            if (searchValue) {
              q1 = query(chatsRef, where("jobTitle", ">=", searchValue), where("jobTitle", "<=", searchValue + "\uf8ff"));
              qGroup = query(groupChatsRef, where("groupName", ">=", searchValue), where("groupName", "<=", searchValue + "\uf8ff"));
            } else {
              q1 = chatsRef; // Fetch all chats if no searchValue is provided
              qGroup = groupChatsRef;
            }
          } else {
            // Non-admin: Fetch chats where senderId or receiverId matches the userId based on searchValue (if provided)
            if (searchValue) {
              q1 = query(chatsRef, where("jobTitle", ">=", searchValue), where("jobTitle", "<=", searchValue + "\uf8ff"));
              q2 = query(chatsRef, where("jobTitle", ">=", searchValue), where("jobTitle", "<=", searchValue + "\uf8ff"));
              qGroup = query(groupChatsRef, where("groupName", ">=", searchValue), where("groupName", "<=", searchValue + "\uf8ff"));
            } else {
              q1 = query(chatsRef, where("senderId", "==", userId));
              q2 = query(chatsRef, where("receiverId", "==", userId));

              const userDetails = {
                id :  userInfo?.id,
                email: userInfo?.email,
                firstName: userInfo?.firstName,
                lastName: userInfo?.lastName,
                roleType: userInfo?.roleEntities[0]?.roleType
              }

              console.log("userdetails=======", userDetails)
              qGroup = query(groupChatsRef, where("members", "array-contains", userDetails));
            }
          }
      
          // Fetch initial data
          if (searchValue) {
            const searchSnapshot = await getDocs(q1);
            chatDocs = searchSnapshot.docs;
          } else if (!isAdmin) {
            const [senderSnapshot, receiverSnapshot] = await Promise.all([getDocs(q1), getDocs(q2)]);
            const groupChatsSnapshot = await getDocs(qGroup);
            chatDocs = [...senderSnapshot.docs, ...receiverSnapshot.docs];
            groupChatDocs = groupChatsSnapshot.docs;
          } else {
            const allChatsSnapshot = await getDocs(q1);
            const groupChatsSnapshot = await getDocs(qGroup);
            chatDocs = allChatsSnapshot.docs;
            groupChatDocs = groupChatsSnapshot.docs;
          }
      
          // Extract data from initial chat documents
          let chats = chatDocs.map(doc => doc.data());
          let groupChats = groupChatDocs.map(doc => doc.data());

          console.log("groupChats===========",groupChats)
          console.log("chats===========",chats)

          let allChats = [...chats, ...groupChats];
      
          // Sort chats based on the modifiedOn field
          const sortedChats = allChats.sort((a, b) => b?.modifiedOn?.toDate() - a?.modifiedOn?.toDate());
      
          console.log("sortedChats=========",sortedChats)
          // Filter chats based on senderId and receiverId
          let filteredChats = [];
          // if(isAdmin){
          //   filteredChats = sortedChats;
          // }else{
          //   filteredChats = sortedChats.filter(chat => chat.senderId === userId || chat.receiverId === userId || chat.members?.some(member => member.id === userId));
          // }

          if(role_type?.includes("ROLE_OPENSTAFF_ADMIN")){
            filteredChats = sortedChats;
          }else{
            filteredChats = sortedChats?.filter(chat => {
            const isGroupAdmin = chat?.groupName === 'Admin';
            const members = chat?.members || [];

            if (role_type?.includes('ROLE_INSTITUTION_POSTER_ADMIN') || role_type?.includes('ROLE_OPENSTAFF_FINANCIAL_ADMIN')) {
              if (isGroupAdmin) {
                // Exclude if any member has roleType ROLE_USER
                return !members.some(member => member?.roleType === 'ROLE_USER');
              }
              return true; 
            }

            if (role_type?.includes('ROLE_SEEKER_USER_ADMIN')) {
              if (isGroupAdmin) {
                // Exclude if any member has roleType ROLE_INSTITUTION_ADMIN
                return !members.some(member => member?.roleType === 'ROLE_INSTITUTION_ADMIN');
              }
              return true; 
            }

            // Fallback: only show chats user is involved in
            return chat.senderId === userId || chat.receiverId === userId || members.some(member => member.id === userId);
            });
          }
          


          console.log("filteredChats=========",filteredChats)
          // const filteredChats = sortedChats.filter(chat => chat.senderId === userId || chat.receiverId === userId);
          // Set initial state with sorted and filtered chats
          setJobId(id ? id : filteredChats?.length > 0 ? filteredChats[0]?.groupId ? filteredChats[0]?.groupId : filteredChats[0]?.jobId : null);
          if(filteredChats?.length > 0 && filteredChats[0]?.groupId){
            setIsGroupChat(true)
          }else{
            setIsGroupChat(false)
          }
          setJobIdAndGroupStatus({
            jobid: id ? id : filteredChats?.length > 0 ? filteredChats[0]?.groupId ? filteredChats[0]?.groupId : filteredChats[0]?.jobId : null,
            isGroupChat: filteredChats?.length > 0 && filteredChats[0]?.groupId ? true : false
          })
          setChatList(filteredChats);
          setIsJobList(false);
      
          // Real-time listeners
          const unsubscribeListeners = [];
      
          // const handleSnapshot = (snapshot) => {
          //   snapshot.docChanges()?.forEach(change => {
          //     const updatedChat = change.doc.data();
          //     if (change.type === 'added' || change.type === 'modified') {
          //       setChatList(prevChats => {
          //         // Update chats if they already exist or add new chats if not present
          //         let updatedChats = prevChats.map(chat => {
          //           if (chat.jobId === updatedChat.jobId || chat.groupId === updatedChat.groupId) {
          //             return updatedChat; // Replace existing chat with updated one
          //           }
          //           return chat; // Keep other chats unchanged
          //         });
          
          //         // Add the chat if it doesn't already exist
          //         if (!prevChats.some(chat => chat.jobId === updatedChat.jobId || chat.groupId === updatedChat.groupId)) {
          //           updatedChats.push(updatedChat);
          //        }
          
          //         // Sort chats based on the modifiedOn field
          //         updatedChats = updatedChats.sort((a, b) => b?.modifiedOn?.toDate() - a?.modifiedOn?.toDate());
          
          //         // Conditionally filter chats based on isAdmin status
          //         if (!isAdmin) {
          //           // Apply filter when not an admin
          //           return updatedChats.filter(chat => chat.senderId === userId || chat.receiverId === userId || chat.members?.some(member => member.id === userId));
          //         }

          //         console.log("updatedChats========",updatedChats)
          
          //         // When isAdmin is true, don't filter the chats
          //         return updatedChats;
          //       });
          //     }
          //     if (change.type === 'removed') {
          //       setChatList(prevChats => prevChats.filter(chat => chat.jobId !== updatedChat.jobId && chat.groupId !== updatedChat.groupId));
          //     }
          //   });
          // };

          const handleSnapshot = (snapshot) => {
            setChatList((prevChats) => {
              // Create a map to hold unique chats using jobId or groupId as key.
              const chatMap = {};
              prevChats.forEach((chat) => {
                const key = chat.jobId ? chat.jobId : chat.groupId;
                if (key) chatMap[key] = chat;
              });
      
              snapshot.docChanges().forEach((change) => {
                const updatedChat = change.doc.data();
                const key = updatedChat.jobId ? updatedChat.jobId : updatedChat.groupId;
                if (change.type === "removed") {
                  delete chatMap[key];
                } else {
                  // For added or modified, simply update the map.
                  chatMap[key] = updatedChat;
                }
              });
      
              // Build updated chats array from map values
              let updatedChats = Object.values(chatMap);
      
              // Sort the array by modifiedOn field (latest first)
              updatedChats.sort((a, b) => b?.modifiedOn?.toDate() - a?.modifiedOn?.toDate());
      
              // For non-admin users, filter chats
              if (!isAdmin) {
                updatedChats = updatedChats.filter(
                  (chat) =>
                    chat.senderId === userId ||
                    chat.receiverId === userId ||
                    (chat.members && chat.members.some((member) => member.id === userId))
                );
              }
      
              console.log("updatedChats========", updatedChats);
              return updatedChats;
            });
          };
          
      
          if (isAdmin) {
            const unsubscribeAdmin = onSnapshot(q1, handleSnapshot);
            unsubscribeListeners.push(unsubscribeAdmin);
          } else {
            const unsubscribeSender = onSnapshot(q1, handleSnapshot);
            unsubscribeListeners.push(unsubscribeSender);
            if (!searchValue) {
              const unsubscribeReceiver = onSnapshot(q2, handleSnapshot);
              unsubscribeListeners.push(unsubscribeReceiver);
            }

            const unsubscribeGroupChats = onSnapshot(qGroup, handleSnapshot);
            unsubscribeListeners.push(unsubscribeGroupChats);
          }
      
          // Clean up listeners on component unmount or as needed
          return () => unsubscribeListeners?.forEach(unsubscribe => unsubscribe());
        } catch (error) {
          console.error("Error getting documents:", error);
        }
      };
      
  
  // console.log('jobId:::::::::::::::::::::',jobId)
      const handleSelectionChat=(job_id, status)=>{
        console.log("jobbbbbbbiidddd",job_id)
        setIsGroupChat(status)
        setJobId(job_id)
        setSelectedChatJobId(job_id)
        setJobIdAndGroupStatus({
          jobid: job_id,
          isGroupChat: status
        })
      }
    useEffect(()=>{
        loadScript("js/custom.js")
    })
    const fetchJobList=async()=>{
      let result={
        data:{
          content:[]
        }
      }
      if(userInfo?.roleEntities[0]?.roleType=='ROLE_USER'){
      const fetchJobs = async (api) => {
        const commonParams=`&category=All&sortBy=recentJobs&sortDirection=desc&offset=0&page=0&size=100&searchkey=${
        searchValue
      }`
        return apiCall(api + commonParams, "GET", null, TOKEN);
      };
      const api1 = `jobs/applied2?jobEntity.jobStatus=eOpen`;
      const api2 = `jobs/applied2?jobEntity.jobStatus=eAccepted&hired=true`;
      const api3 = `jobs/applied2?jobEntity.jobStatus=eInProgress`;
      const [result1, result2, result3] = await Promise.all([
        fetchJobs(api1),
        fetchJobs(api2),
        fetchJobs(api3),
      ]);

      result = {
        data: {
          content: [
            ...(Array.isArray(result1?.data?.content) ? result1.data.content : []),
            ...(Array.isArray(result2?.data?.content) ? result2.data.content : []),
            ...(Array.isArray(result3?.data?.content) ? result3.data.content : []),
          ],
          totalElements:
            (result1?.data?.totalElements || 0) + 
            (result2?.data?.totalElements || 0) + 
            (result3?.data?.totalElements || 0),
          totalPages: Math.max(
            result1?.data?.totalPages || 0,
            result2?.data?.totalPages || 0,
            result3?.data?.totalPages || 0
          ),
        },
      }
    }else if(userInfo?.roleEntities[0]?.roleType=='ROLE_INSTITUTION_ADMIN'){
        let apiBase = `${`institutions/jobs?jobStatus=eInProgress&jobStatus=eAccepted&category=All&sortBy=recentJobs&sortDirection=desc&offset=0&page=0&size=100&searchkey=${
          searchValue
          }`}`
          result = await apiCall(apiBase, "GET", null, TOKEN);
      }
      setJobLists(result?.data?.content)
      // console.log('')
    }
    console.log('chaChats=========',chatList)
    // console.log('jobId:::::::::::::::::',jobId)

    const fetchUsersList = async () => {
      const api = `users/adminUsers?status=All&roleType=All&offset=0&email=&sortBy=recent&sortDirection=desc&page=0&size=10&searchkey=`
        ;
      try {
        const result = await apiCall(api, "GET", null, TOKEN);
        console.log("get user list result=====", result)
        if (result?.data?.content?.length > 0) {
          setAdminDetails(result?.data?.content[0])
        } else {
          setAdminDetails([]);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    return (
        <>
        <div>
          <Helmet>
            <title>{`Chat | ${formatCompanyName()}`}</title>
            <meta name="description" content="" />
            <meta name="keywords" content="chat" />
          </Helmet>
        </div>
        <div className="section-full p-t120  p-b90 site-bg-white">
            <div className="twm-right-section-panel site-bg-gray">
                {/* <div className="wt-admin-dashboard-msg-2  twm-dashboard-style-2" style={{maxWidth:"1470px", margin:"0 auto"}}> */}
                <div className="wt-admin-dashboard-msg-2  twm-dashboard-style-2" style={{maxWidth:"1470px", margin:"0 auto"}}> 
                    {/*Left Msg section*/}
                    <SectionCanChatList jobId={jobId} chatList={chatList} handleSelectionChat={handleSelectionChat} setIsJobList={setIsJobList} isJobList={isJobList} setSearchValue={setSearchValue} searchValue={searchValue} getAllChats={getAllChats} setIsGroupChat={setIsGroupChat} adminDetails={adminDetails} isGroup={isGroupChat} />

                    {/*Right Msg section*/}
                    {isJobList?
                    <div className="twm-right-section-panel candidate-save-job site-bg-gray" style={{width:'100%'}}>
                    {/* <CanJobList isLoading={false} jobLists={jobLists} getAllChats={getAllChats} setIsJobList={setIsJobList} isJobList={isJobList} setJobId={setJobId} setJobIdAndGroupStatus={setJobIdAndGroupStatus} setIsGroupChat={setIsGroupChat} /> */}
                    <CanJobList isLoading={false} jobLists={jobLists} setIsJobList={setIsJobList} isJobList={isJobList} setJobId={setJobId} setJobIdAndGroupStatus={setJobIdAndGroupStatus} setIsGroupChat={setIsGroupChat} setIsStartChat={setIsStartChat} />
                    </div>
                    :jobId?<SectionCanChat jobId={jobId}  getAllChats={getAllChats} selectedChatJobId={selectedChatJobId} isGroup={isGroupChat} jobIdAndGroupStatus={jobIdAndGroupStatus} isStartChat={isStartChat} setIsStartChat={setIsStartChat} />
                    : <div className="wt-dashboard-msg-box">
                      <div style={{ display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh', // Make the container take the full height of the viewport
                        textAlign: 'center'}}>
                        No conversations available here </div>
                        </div>
                    }

                </div>
            </div>
        </div>

        </>
    )
}

export default CanChatPage;